var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBeatmatchHorizontal = function SvgBeatmatchHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 718.441,
    height: 144,
    viewBox: "0 0 718.441 144",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(-10808.559 -3372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(0 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("text", {
    id: "beatmatch",
    transform: "translate(10985 3097)",
    fontSize: 100,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 80
  }, "beatmatch")))), /*#__PURE__*/React.createElement("g", {
    id: "BeatMatchLogo_Lines-02",
    transform: "translate(10808.56 3372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-10736.561-3228a71.54,71.54,0,0,1-28.024-5.658,71.968,71.968,0,0,1-12.231-6.639,72.621,72.621,0,0,1-10.656-8.792,72.5,72.5,0,0,1-8.791-10.656,72.037,72.037,0,0,1-6.639-12.23,71.536,71.536,0,0,1-5.658-28.026,71.536,71.536,0,0,1,5.658-28.026,72.037,72.037,0,0,1,6.639-12.23,72.564,72.564,0,0,1,8.791-10.656,72.57,72.57,0,0,1,10.656-8.792,71.968,71.968,0,0,1,12.231-6.639,71.543,71.543,0,0,1,28.024-5.658,71.556,71.556,0,0,1,28.026,5.658,71.968,71.968,0,0,1,12.231,6.639,72.511,72.511,0,0,1,10.656,8.792,72.53,72.53,0,0,1,8.792,10.656,72.037,72.037,0,0,1,6.639,12.23,71.536,71.536,0,0,1,5.658,28.026,71.536,71.536,0,0,1-5.658,28.026,72.037,72.037,0,0,1-6.639,12.23,72.468,72.468,0,0,1-8.792,10.656,72.511,72.511,0,0,1-10.656,8.792,71.968,71.968,0,0,1-12.231,6.639A71.549,71.549,0,0,1-10736.561-3228Zm.719-115.263a6.858,6.858,0,0,0-6.852,6.849v72.478a6.858,6.858,0,0,0,6.852,6.849,6.857,6.857,0,0,0,6.85-6.849v-72.478A6.857,6.857,0,0,0-10735.842-3343.263Zm23.166,9.185a6.858,6.858,0,0,0-6.85,6.852v54.1a6.858,6.858,0,0,0,6.85,6.852,6.858,6.858,0,0,0,6.85-6.852v-54.1A6.858,6.858,0,0,0-10712.676-3334.078Zm-45.04,5.6a6.857,6.857,0,0,0-6.85,6.849v40.865a6.858,6.858,0,0,0,6.85,6.852,6.858,6.858,0,0,0,6.85-6.852v-40.865A6.857,6.857,0,0,0-10757.716-3328.479Zm-21.486,29.32a6.857,6.857,0,0,0-6.85,6.849v11.545a6.857,6.857,0,0,0,6.85,6.849,6.857,6.857,0,0,0,6.85-6.849v-11.545A6.857,6.857,0,0,0-10779.2-3299.159Zm88.835-22.308a6.857,6.857,0,0,0-6.85,6.849v18.985a6.857,6.857,0,0,0,6.85,6.849,6.857,6.857,0,0,0,6.849-6.849v-18.985A6.857,6.857,0,0,0-10690.367-3321.468Z",
    transform: "translate(10808.56 3372)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeatmatchHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beatmatch-horizontal.b2765396.svg";
export { ForwardRef as ReactComponent };